import { TypographyOptions } from '@mui/material/styles/createTypography';
import { arcosDoradosTheme } from './arcosDoradosTheme';

export const typographyBaseTokens = {
  fontFamilies: {
    primary: [arcosDoradosTheme.typography.family, ...arcosDoradosTheme.typography.fallback].join(
      ','
    ),
    mono: ['Roboto Mono', 'Consolas', 'Monaco', 'monospace'].join(','),
  },
  fontWeights: {
    light: arcosDoradosTheme.typography.weights.light,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: arcosDoradosTheme.typography.weights.bold,
    extrabold: 800,
  },
  fontSizes: {
    xs: '0.688rem',
    sm: '0.75rem',
    md: '0.875rem',
    lg: '1rem',
    xl: '1.25rem',
    xxl: '1.5rem',
  },
  lineHeights: {
    tight: 1.25,
    regular: 1.43,
    relaxed: 1.57,
    spacious: 1.7,
  },
  letterSpacing: {
    tight: '-0.01em',
    normal: '0em',
    wide: '0.08em',
  },
} as const;

export const getSemanticTypographyTokens = (): TypographyOptions => ({
  fontFamily: typographyBaseTokens.fontFamilies.primary,
  fontWeightLight: typographyBaseTokens.fontWeights.light,
  fontWeightRegular: typographyBaseTokens.fontWeights.regular,
  fontWeightMedium: typographyBaseTokens.fontWeights.medium,
  fontWeightBold: typographyBaseTokens.fontWeights.bold,
  h1: {
    fontFamily: typographyBaseTokens.fontFamilies.primary,
    fontWeight: typographyBaseTokens.fontWeights.bold,
    fontSize: typographyBaseTokens.fontSizes.xxl,
    lineHeight: typographyBaseTokens.lineHeights.tight,
    letterSpacing: typographyBaseTokens.letterSpacing.tight,
  },
  h3: {
    fontFamily: typographyBaseTokens.fontFamilies.primary,
    fontWeight: typographyBaseTokens.fontWeights.bold,
    fontSize: typographyBaseTokens.fontSizes.xl,
    lineHeight: typographyBaseTokens.lineHeights.regular,
  },
  h4: {
    fontFamily: typographyBaseTokens.fontFamilies.primary,
    fontWeight: typographyBaseTokens.fontWeights.bold,
    fontSize: typographyBaseTokens.fontSizes.lg,
    lineHeight: typographyBaseTokens.lineHeights.regular,
  },
  h2: {
    fontFamily: typographyBaseTokens.fontFamilies.primary,
    fontWeight: typographyBaseTokens.fontWeights.bold,
    fontSize: typographyBaseTokens.fontSizes.xl,
    lineHeight: typographyBaseTokens.lineHeights.tight,
    letterSpacing: typographyBaseTokens.letterSpacing.tight,
  },
  h5: {
    fontFamily: typographyBaseTokens.fontFamilies.primary,
    fontWeight: typographyBaseTokens.fontWeights.bold,
    fontSize: typographyBaseTokens.fontSizes.xl,
    lineHeight: typographyBaseTokens.lineHeights.tight,
  },
  h6: {
    fontFamily: typographyBaseTokens.fontFamilies.primary,
    fontWeight: typographyBaseTokens.fontWeights.bold,
    fontSize: typographyBaseTokens.fontSizes.lg,
    lineHeight: typographyBaseTokens.lineHeights.regular,
  },
  subtitle1: {
    fontWeight: typographyBaseTokens.fontWeights.bold,
    fontSize: typographyBaseTokens.fontSizes.lg,
    lineHeight: typographyBaseTokens.lineHeights.regular,
  },
  subtitle2: {
    fontWeight: typographyBaseTokens.fontWeights.medium,
    fontSize: typographyBaseTokens.fontSizes.md,
    lineHeight: typographyBaseTokens.lineHeights.regular,
    letterSpacing: typographyBaseTokens.letterSpacing.normal,
  },
  body1: {
    fontWeight: typographyBaseTokens.fontWeights.regular,
    fontSize: typographyBaseTokens.fontSizes.lg,
    lineHeight: typographyBaseTokens.lineHeights.relaxed,
  },
  body2: {
    fontWeight: typographyBaseTokens.fontWeights.light,
    fontSize: typographyBaseTokens.fontSizes.md,
    lineHeight: typographyBaseTokens.lineHeights.regular,
  },
  caption: {
    fontWeight: typographyBaseTokens.fontWeights.light,
    fontSize: typographyBaseTokens.fontSizes.sm,
    lineHeight: typographyBaseTokens.lineHeights.regular,
  },
  overline: {
    fontWeight: typographyBaseTokens.fontWeights.extrabold,
    fontSize: typographyBaseTokens.fontSizes.xs,
    lineHeight: typographyBaseTokens.lineHeights.regular,
    letterSpacing: typographyBaseTokens.letterSpacing.wide,
    textTransform: 'uppercase',
  },
  button: {
    fontWeight: typographyBaseTokens.fontWeights.bold,
    fontSize: typographyBaseTokens.fontSizes.md,
    lineHeight: typographyBaseTokens.lineHeights.regular,
    textTransform: 'none',
    letterSpacing: typographyBaseTokens.letterSpacing.normal,
  },
});
